export const SiteDot = ({ height = 4, width = 4, color = '#1C3A13' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 4 4'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='2' cy='2' r='2' style={{ fill: color }} />
  </svg>
);
